<div class="expanded-panel-header purple" (click)="toggleExpand()">Project Credits</div>
@if(expanded){
  <div class="row">
    <table>
      <thead>
        <tr>
          <th>Type</th>
          <th>4%/9%</th>
          <th>Credit Status</th>
          <th>Equity</th>
          <th>Price Per Credit</th>
          <th>Certificated</th>
        </tr>
      </thead>
      <tbody>
        @for(credit of dataArr; track $index){
          <tr>
            <td>{{ credit.type ?? '--'}}</td>
            <td>{{ credit.designation ?? '--'}}</td>
            <td>{{ credit.credit_status ?? '--'}}</td>
            <td>{{ credit.equity ? (credit.equity | currency: 'USD': 'symbol': '1.0-0' ) : '--'}}</td>
            <td>{{ credit.price ? (credit.price | currency: 'USD': 'symbol': '1.4-4' ) : '--'}}</td>
            <td>{{ credit.certificated ? 'Yes' : 'No' }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}
